module.exports = __webpack_public_path__ + "static/media/IMG_4285.765415c6.PNG";